angular.module('gym.components').directive('perEventTypeDailyLimit', function() {
  return {
    restrict: 'E',
    template: require('templates/components/membership_plan/per_event_type_daily_limit.html.slim'),
    scope: {
      data: '=',
      types: '='
    },
    controller: ["$scope", "$rootScope", "isInteger", function($scope, $rootScope, isInteger) {
      var getTypeLimits;
      $scope.typeLimits = {};
      $scope.limitOptions = [void 0].concat([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
      $scope.dateUnits = [['days', 'day(s)'], ['weeks', 'week(s)'], ['months', 'month(s)']];
      getTypeLimits = function(id) {
        return _.find($scope.data.per_event_type_limits, function(item) {
          return item.event_type_id === id;
        });
      };
      $scope.$watch('data.event_type_ids', function(ids) {
        if (ids) {
          _.each(ids, function(id) {
            var existingLimit, ref, ref1, ref2;
            existingLimit = getTypeLimits(id);
            return $scope.typeLimits[id] = {
              event_type_id: id,
              limit: (existingLimit != null ? existingLimit.limit : void 0) || ((ref = $scope.typeLimits[id]) != null ? ref.limit : void 0),
              date_range_number: (existingLimit != null ? existingLimit.date_range_number : void 0) || ((ref1 = $scope.typeLimits[id]) != null ? ref1.date_range_number : void 0) || 1,
              date_range_unit: (existingLimit != null ? existingLimit.date_range_unit : void 0) || ((ref2 = $scope.typeLimits[id]) != null ? ref2.date_range_unit : void 0) || 'days'
            };
          });
        }
        return $scope.updateLimits();
      }, true);
      $scope.numberInvalid = function(typeId) {
        var number;
        number = $scope.typeLimits[typeId].date_range_number;
        return $scope.typeLimits[typeId].limit && (!isInteger(number) || !number || number < 1);
      };
      $scope.updateLimits = function() {
        var newLimits;
        newLimits = _.map($scope.typeLimits, function(limits, id) {
          if (!limits.limit) {
            return void 0;
          }
          return limits;
        });
        return $scope.data.per_event_type_limits = _.compact(newLimits);
      };
      return $scope.getType = function(id) {
        return _.find($scope.types, function(type) {
          return type.id === id;
        });
      };
    }]
  };
});
